export default function StakeForVotingIcon() {
  return (
    <svg
      width="35"
      height="36"
      viewBox="0 0 35 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.9864 31.5206L31.7389 18.028C31.6585 17.5457 31.2413 17.1923 30.7524 17.1923H29.0031L32.368 11.364C32.5007 11.1343 32.5366 10.8613 32.4679 10.6052C32.3993 10.349 32.2317 10.1305 32.002 9.99797L20.1134 3.13398C19.8837 3.00136 19.6108 2.96542 19.3546 3.03411C19.0984 3.10273 18.8799 3.27036 18.7474 3.50004L10.8422 17.1922H5.24758C4.7587 17.1922 4.34151 17.5457 4.26114 18.0279L2.01358 31.5206C1.96533 31.8106 2.04702 32.1071 2.23702 32.3313C2.42702 32.5556 2.70608 32.685 3.00002 32.685H33C33.2939 32.685 33.573 32.5556 33.763 32.3313C33.953 32.1071 34.0347 31.8106 33.9864 31.5206ZM19.9794 5.36604L30.136 11.23L22.7987 23.9385H16.4394L11.0523 20.8283L19.9794 5.36604ZM4.18039 30.6849L6.09476 19.1922H9.68751L8.82026 20.6943C8.54413 21.1727 8.70801 21.7842 9.18626 22.0603L12.4394 23.9385H8.5867C8.03445 23.9385 7.5867 24.3863 7.5867 24.9385C7.5867 25.4908 8.03445 25.9385 8.5867 25.9385H27.4133C27.9656 25.9385 28.4133 25.4908 28.4133 24.9385C28.4133 24.3863 27.9656 23.9385 27.4133 23.9385H25.1081L27.8484 19.1922H29.9052L31.8196 30.6849H4.18039Z"
        fill="black"
      />
    </svg>
  );
}
